import type { FC, ReactNode } from 'react';
import { Box, Grid } from '@mui/material';

import type { DashboardWidgetProps, GridSizeOrGrow } from 'src/types/dashboard';
import { WIDGET_WRAPPER_TEST_ID } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper';
import WidgetHashLink from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/components/widgetHashLink';
import useWidgetChartConfig from 'src/components/dashboard/hooks/useWidgetChartConfig';

import { styles as widgetStyles } from 'src/components/dashboard/DashboardPage/components/WidgetWrapper/components/widgetGridWrapper.styles';

interface WidgetGroupItemFrameProps extends DashboardWidgetProps {
  children: ReactNode;
  gridSizeMd?: GridSizeOrGrow;
  gridSizeLg?: GridSizeOrGrow;
  gridSizeXl?: GridSizeOrGrow;
  guidedTour?: ReactNode;
}

const WidgetGroupItemFrame: FC<WidgetGroupItemFrameProps> = ({
  gridSizeMd = 12,
  gridSizeLg = 12,
  gridSizeXl,
  config,
  className,
  guidedTour = null,
  children,
}) => {
  const { backgroundColor, fontWeight, fontSize } =
    useWidgetChartConfig(config);

  return (
    <Grid
      item
      xs={12}
      md={gridSizeMd === 'grow' ? true : gridSizeMd}
      lg={gridSizeLg === 'grow' ? true : gridSizeLg}
      xl={
        gridSizeXl === 'grow'
          ? true
          : gridSizeXl ?? (gridSizeLg === 'grow' ? true : gridSizeLg)
      }
      id={`widget-${config.id}`}
      className={className}
      sx={widgetStyles.widgetContainer}
      data-test-id={WIDGET_WRAPPER_TEST_ID}
    >
      {guidedTour}
      <Box sx={widgetStyles.widget(backgroundColor, fontWeight, fontSize)}>
        <WidgetHashLink internalLink={config.internal_link}>
          {children}
        </WidgetHashLink>
      </Box>
    </Grid>
  );
};

export default WidgetGroupItemFrame;
